/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Dashboard components
import {
  Button,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
} from "@mui/material";
import FairData from "layouts/tables/data/fairTableData";
import { useEffect, useState } from "react";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import moment from "moment";

function AddFair({ visible, onClose, onSubmit, fairData }) {
  const [fairName, setFairName] = useState("");
  const [fairCode, setFairCode] = useState("");
  const [venue, setVenue] = useState("");
  const [address, setAddress] = useState("");
  const [directionLink, setDirectionLink] = useState("");
  const [description, setDescription] = useState("");
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [startTime, setStartTime] = useState(moment().format("HH:mm"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [endTime, setEndTime] = useState(moment().format("HH:mm"));

  const [isSubmitted, setIsSubmitted] = useState(false);

  const [selectedCode, setSelectedCode] = useState("+91");
  const [mobile, setMobile] = useState("");

  const countryCodes = [
    { code: "+91", label: "🇮🇳" },
    { code: "+1", label: "🇺🇸" },
    { code: "+44", label: "🇬🇧" },
    { code: "+61", label: "🇦🇺" },
    // Add more as needed
  ];

  const arrStatus = [
    { key: "planned", name: "Planned" },
    { key: "ongoing", name: "Ongoing" },
    { key: "completed", name: "Completed" },
    { key: "cancelled", name: "Cancelled" },
  ];
  const [status, setStatus] = useState(arrStatus.find((item) => item.key === fairData?.status));

  useEffect(() => {
    setFairName(fairData?.name || "");
    setFairCode(fairData?.fairCode || "");
    setVenue(fairData?.venue || "");
    setAddress(fairData?.address || "");
    setDescription(fairData?.description || "");
    setDirectionLink(fairData?.directionLink || "");
    setStartDate(moment(fairData?.startDate).format("YYYY-MM-DD"));
    setStartTime(moment(fairData?.startDate).format("HH:mm"));
    setEndDate(moment(fairData?.endDate).format("YYYY-MM-DD"));
    setEndTime(moment(fairData?.endDate).format("HH:mm"));
    setSelectedCode(fairData?.code || "+91");
    setMobile(fairData?.phone || "");
  }, []);

  const handleAdd = () => {
    if (
      fairName === "" ||
      fairCode === "" ||
      venue === "" ||
      address === "" ||
      directionLink === "" ||
      status === undefined ||
      selectedCode === "" ||
      mobile === ""
    ) {
      setIsSubmitted(true);
    } else {
      setIsSubmitted(false);
      var params = {
        name: fairName.trim(),
        startDate: moment(`${startDate} ${startTime}`, "YYYY-MM-DD HH:mm").toDate(),
        endDate: moment(`${endDate} ${endTime}`, "YYYY-MM-DD HH:mm").toDate(),
        fairCode: fairCode.trim(),
        venue: venue,
        address: address,
        directionLink: directionLink,
        description: description,
        status: status.key,
        code: selectedCode,
        phone: mobile,
      };

      if (fairData) {
        updateFairApi(params, fairData?._id);
      } else {
        createFairApi(params);
      }
    }
  };

  const updateFairApi = (params, id) => {
    updateFair({
      params: params,
      id: id,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            notify();
            onSubmit && onSubmit();
          }
        }
      })
      .catch((e) => {})
      .finally(() => {});
  };

  const createFairApi = async (params) => {
    createFair({
      params: params,
    })
      .then((responseJson) => {
        if (responseJson) {
          if (responseJson?.status === 400) {
          } else {
            notify();
            onSubmit && onSubmit();
          }
        }
      })
      .catch((e) => {});
  };

  return (
    <Dialog open={visible}>
      <DialogTitle>Fair</DialogTitle>
      <DialogContent>
        <MDBox display="flex" gap={2} mt={1} mb={2} flexDirection={{ xs: "column", sm: "row" }}>
          <MDInput
            label={
              <>
                Fair Name
                <span style={{ color: "red" }}>*</span>
              </>
            }
            type="text"
            fullWidth
            value={fairName}
            onChange={(e) => setFairName(e.target.value)}
            helperText={isSubmitted && !fairName ? "Fair name is required" : ""}
            FormHelperTextProps={{
              sx: {
                color: "red",
                marginLeft: "0",
              },
            }}
          />
          <MDInput
            label={
              <>
                Fair Code
                <span style={{ color: "red" }}>*</span>
              </>
            }
            type="text"
            fullWidth
            value={fairCode}
            onChange={(e) => setFairCode(e.target.value)}
            helperText={isSubmitted && !fairCode ? "Fair code is required" : ""}
            FormHelperTextProps={{
              sx: {
                color: "red",
                marginLeft: "0",
              },
            }}
          />
        </MDBox>
        <MDBox display="flex" gap={2} mt={1} mb={2} flexDirection={{ xs: "column", sm: "row" }}>
          <MDBox display="flex" gap={1}>
            <MDInput
              label={
                <>
                  Start Date
                  <span style={{ color: "red" }}>*</span>
                </>
              }
              type="date"
              //   fullWidth
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              helperText={isSubmitted && !startDate ? "Start date is required" : ""}
              FormHelperTextProps={{
                sx: {
                  color: "red",
                  marginLeft: "0",
                },
              }}
            />
            <MDInput
              label={
                <>
                  Time
                  <span style={{ color: "red" }}>*</span>
                </>
              }
              type="time"
              //   fullWidth
              sx={{ width: "100px" }}
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
              helperText={isSubmitted && !startTime ? "Start time is required" : ""}
              FormHelperTextProps={{
                sx: {
                  color: "red",
                  marginLeft: "0",
                },
              }}
            />
          </MDBox>
          <MDBox display="flex" gap={1}>
            <MDInput
              label={
                <>
                  End Date
                  <span style={{ color: "red" }}>*</span>
                </>
              }
              type="date"
              //   fullWidth
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              helperText={isSubmitted && !endDate ? "End date is required" : ""}
              FormHelperTextProps={{
                sx: {
                  color: "red",
                  marginLeft: "0",
                },
              }}
            />
            <MDInput
              label={
                <>
                  Time
                  <span style={{ color: "red" }}>*</span>
                </>
              }
              type="time"
              //   fullWidth
              sx={{ width: "100px" }}
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
              helperText={isSubmitted && !endTime ? "End time is required" : ""}
              FormHelperTextProps={{
                sx: {
                  color: "red",
                  marginLeft: "0",
                },
              }}
            />
          </MDBox>
        </MDBox>
        <MDBox display="flex" gap={2} mt={0}>
          <MDInput
            label={
              <>
                Venue
                <span style={{ color: "red" }}>*</span>
              </>
            }
            type="text"
            fullWidth
            value={venue}
            onChange={(e) => setVenue(e.target.value)}
            sx={{ mb: 2 }}
            helperText={isSubmitted && !venue ? "Venue is required" : ""}
            FormHelperTextProps={{
              sx: {
                color: "red",
                marginLeft: "0",
              },
            }}
          />
        </MDBox>
        <MDBox display="flex" gap={2} mt={0}>
          <MDInput
            label={
              <>
                Address
                <span style={{ color: "red" }}>*</span>
              </>
            }
            type="text"
            fullWidth
            multiline
            maxRows={3}
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            sx={{
              mb: 2,
              "& .MuiInputBase-input": {
                maxHeight: "42px", // Let text expand
                minHeight: "42px", // About 3 lines height
              },
            }}
            helperText={isSubmitted && !address ? "Address is required" : ""}
            FormHelperTextProps={{
              sx: {
                color: "red",
                marginLeft: "0",
              },
            }}
          />
        </MDBox>
        <MDBox display="flex" gap={2} mt={0} mb={2} flexDirection={{ xs: "column", sm: "row" }}>
          <MDInput
            label={
              <>
                Direction Link
                <span style={{ color: "red" }}>*</span>
              </>
            }
            type="text"
            fullWidth
            value={directionLink}
            onChange={(e) => setDirectionLink(e.target.value)}
            helperText={isSubmitted && !directionLink ? "Direction link is required" : ""}
            FormHelperTextProps={{
              sx: {
                color: "red",
                marginLeft: "0",
              },
            }}
          />
          <MDInput
            select
            label={
              <>
                Status
                <span style={{ color: "red" }}>*</span>
              </>
            }
            value={JSON.stringify(status)}
            onChange={(e) => setStatus(JSON.parse(e.target.value))}
            fullWidth
            InputProps={{ sx: { height: "44px" } }}
            SelectProps={{
              MenuProps: {
                PaperProps: {
                  style: {
                    maxHeight: 200,
                    maxWidth: 200,
                  },
                },
              },
            }}
          >
            {arrStatus.map((item) => (
              <MenuItem key={item?.key} value={JSON.stringify(item)}>
                {item?.name}
              </MenuItem>
            ))}
          </MDInput>
        </MDBox>
        <MDBox display="flex" gap={2} mt={0}>
          <MDInput
            label={<>Description</>}
            type="text"
            fullWidth
            multiline
            maxRows={3}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            sx={{
              mb: 2,
              "& .MuiInputBase-input": {
                maxHeight: "42px", // Let text expand
                minHeight: "42px", // About 3 lines height
              },
            }}
          />
        </MDBox>
        <MDBox mb={2} display="flex" gap={2}>
          <MDInput
            disabled
            select
            label="Code"
            value={selectedCode}
            onChange={(e) => setSelectedCode(e.target.value)}
            sx={{ minWidth: 80 }}
            InputProps={{ sx: { height: "44px" } }}
          >
            {countryCodes.map((country) => (
              <MenuItem key={country.code} value={country.code}>
                {country.label} {country.code}
              </MenuItem>
            ))}
          </MDInput>
          <MDInput
            type="mobile"
            label={
              <>
                Mobile Number<span style={{ color: "red" }}>*</span>
              </>
            }
            fullWidth
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
            helperText={isSubmitted && !mobile ? "Mobile number is required" : ""}
            FormHelperTextProps={{
              sx: {
                color: "red",
                marginLeft: "0",
              },
            }}
          />
        </MDBox>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            onClose && onClose();
            setIsSubmitted(false);
            setFairName("");
          }}
          color="error"
          variant="contained"
        >
          Cancel
        </Button>
        <MDButton onClick={handleAdd} color="info">
          Save
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

import PropTypes from "prop-types";
import { updateFair } from "api";
import { createFair } from "api";
import { notify } from "utilities";

AddFair.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  fairData: PropTypes.object,
};

export default AddFair;
